import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import Modal from 'react-modal';
import { addToSSObject } from '../../utils/react';
import { useNavigate } from 'react-router';

import * as _actionsJourney from '../../actions/journey1';
import * as _actionsProduct from '../../actions/product';
import { RootState } from '../../reducers';
import { getParameterByName } from '../../utils/toSearchParams';
import { PartiallyIntegratedUserDataEC } from '../../reducers/app';

Modal.setAppElement('#root');

interface Props {
  actionsJourney: typeof _actionsJourney;
  actionsProduct: typeof _actionsProduct;
  userDataEC: PartiallyIntegratedUserDataEC;
  location: any;
}

const URLParameter = (props: Props) => {
  const navigate = useNavigate();

  useEffect(() => {
    let fetchCount = 0;
    const productidParam = getParameterByName('productid', props.location.search);
    const typeParam = getParameterByName('type', props.location.search) ?? '';
    const addingParam = getParameterByName('adding', props.location.search) ?? '';
    const preFetchProduct =
      typeParam === 'digital'
        ? 'it21/dn::'
        : typeParam === 'analog'
          ? 'it21/af::'
          : typeParam === 'traffic'
            ? 'it21/tn::'
            : '';
    if (productidParam) {
      const resetLocations = Object.keys(props.userDataEC.locations).length > 0 && addingParam !== 'true';
      if (resetLocations) {
        addToSSObject('userDataEC', 'locations', {});
        props.userDataEC.locations = {};
        fetchCount = 0;
      }
      const productidArray = productidParam.split(' ');
      productidArray.map((productid, index) => {
        props.actionsProduct
          .fetchProductByUrn({ urn: preFetchProduct + productid })
          .then((res) => {
            const dataIsArray = Array.isArray(res.data);
            const dataArray = dataIsArray ? res.data : [res.data];
            dataArray.map((data) => {
              const preAddLocation =
                data.producttype === 'digital'
                  ? 'it21/dn'
                  : data.producttype === 'analog'
                    ? 'it21/af'
                    : data.producttype === 'traffic'
                      ? 'it21/tn'
                      : 'it21';
              const preAddress = dataIsArray ? preAddLocation + ':' : '';

              props.actionsJourney.addLocation({
                address: preAddress + productid,
                lngLtd: {
                  lat: data.latitude,
                  lng: data.longitude,
                },
                types: ['product_id'],
                product: {
                  id: preAddLocation + ':id:' + productid,
                },
                context: 'id',
              });
              return true;
            });
            fetchCount++;
            if (productidArray.length == fetchCount) {
              navigate(`/journey2/4`);
            }
          })
          .catch((error) => {
            fetchCount++;
            if (productidArray.length == fetchCount) {
              navigate(`/journey2/4`);
            }
          });
        return true;
      });
    }
  }, []);

  return <div></div>;
};

function mapStateToProps(state: RootState, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    dispatch: dispatch,
    actionsJourney: bindActionCreators(_actionsJourney as any, dispatch),
    actionsProduct: bindActionCreators(_actionsProduct as any, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(URLParameter);
